<template>
  <div class="w-full">
    <div class="float-tile white-tile top-tile" />
    <div class="float-tile transparent-tile left-24 -top-14 bg-gradient-to-b from-blue-start to-blue-end top-tile" />
    <div class="flex justify-center items-center min-h-screen z-10 relative">
      <div class="w-full md:w-8/12 xl:w-4/12 max-w-lg">
        <div class="rounded p-5">
          <logo class="h-20 mb-8 mx-auto" />
          <h1 class="text-3xl font-black text-bs-dark-bg dark:text-white mb-8">Join the fastest growing <br />data-driven tipster platform!</h1>
          <div class="card-body">
            <div
              v-if="error"
              class="bg-red text-white mb-8"
            >{{ error }}</div>

            <div class="mb-4 relative text-left">
              <label class="font-medium block pb-3 text-sm dark:text-white">Name &amp; Surname</label>
              <input
                class="block bg-bs-gray rounded-lg px-5 py-3 w-full outline-none text-bs-gray-dark"
                id="username"
                v-model="form.name"
                type="text"
                autofocus
                placeholder="Enter your name"
              />
            </div>
            <div class="mb-4 relative text-left">
              <label class="font-medium block pb-3 text-sm dark:text-white">E-mail</label>
              <input
                class="block bg-bs-gray rounded-lg px-5 py-3 w-full outline-none text-bs-gray-dark"
                id="email"
                type="email"
                v-model="form.email"
                autofocus
                placeholder="Enter your email"
              />
            </div>
            <div class="mb-4 relative text-left">
              <label class="font-medium block pb-3 text-sm dark:text-white">Password</label>
              <input
                class="block bg-bs-gray rounded-lg px-5 py-3 w-full outline-none text-bs-gray-dark"
                id="password"
                type="password"
                v-model="form.password"
                placeholder="Enter your password"
              />
            </div>
            <div class="mb-4 relative text-left flex justify-start items-center">

              <input
                class="block bg-bs-gray rounded-lg px-5 py-3 w-6 h-6 mr-4 outline-none text-bs-gray-dark"
                id="terms"
                type="checkbox"
                v-model="form.terms"
              />
              <label
                class="font-medium block text-sm dark:text-white"
                for="terms"
              >I accept the <router-link to="/terms" class="font-bold text-bs-blue-dark">Terms &amp; Conditions</router-link></label>
            </div>

            <div class="text-left bg-red-400 border-bs-red border-2 px-3 py-5 rounded-lg" v-if="error">
              {{error}}  
            </div>
            <div class="text-left">
              <button
                type="submit"
                class="btn-primary w-full mt-4"
                :class="[registeringViaEmail ? 'opacity-80': '']"
                @click.prevent="submit"
                :disabled="registeringViaEmail"
              >
                <spinner class="transform scale-50 -my-6" v-if="registeringViaEmail" /> <span v-else>Join Now</span>
              </button>
              
            </div>
            <div class="mt-8 mb-4 flex gap-4">
              <button
                class="facebook"
                @click.prevent="registerWithFb"
              >
                <font-awesome-icon
                  :icon="['fab', 'facebook']"
                  class="w-4 mr-3"
                  size="lg"
                />
                <span class="w-10/12">Join with Facebook</span>
              </button>

              <button
                class="google"
                @click.prevent="registerWithGoogle"
              >
                <font-awesome-icon
                  :icon="['fab', 'google']"
                  class="w-4 mr-3"
                  size="lg"
                />
                <span class="w-10/12">Join with Google</span>
              </button>
            </div>
            <div class="mt-8">
              <p class="dark:text-white">Already have an account? <router-link
                  to="/login"
                  class="font-bold text-bs-blue-dark"
                >Login Here</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-tile white-tile fixed-bottom-tile-position bottom-tile" />
    <div class="float-tile transparent-tile right-24 -bottom-20 bg-gradient-to-b from-green-start to-green-end bottom-tile" />
  </div>
</template>


<script>
import firebase from '@/firebase'
import Logo from '../../atoms/Logo.vue';
import { v4 as uuidv4 } from 'uuid';
import Spinner from '../../atoms/Spinner.vue';

const PASSWORD_REGEX=  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;


export default {
  components: { Logo, Spinner },
  
  data () {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        terms: false
      },
      error: null,
      registeringViaEmail: false
    };
  },
  methods: {
    validateEmail: function (email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    checkTerms: function(){
      
      if (!this.form.terms){
        this.error = "Please agree to our Terms and Conditions"
        return false
      }
      this.error = null
      return true
    },
    submit () {
      if (this.form.name.length < 5){
        this.error = "Please enter your name & surname."
        return false
      }
      if (!this.validateEmail(this.form.email)){
        this.error = "Please enter a valid email address."
        return false
      }
      if (!PASSWORD_REGEX.test(this.form.password)){
        this.error = "Please enter a password. Minimum 8 characters, at least has a number and a special character."
        return false
      }
      if (this.checkTerms()){
        this.registeringViaEmail = true;
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.form.email, this.form.password)
          .then(data => {
            data.user
              .updateProfile({
                displayName: this.form.name
              })
              .then(() => {
                this.registeringViaEmail = false;
                this.navigate();
              });
          })
          .catch(err => {
            this.registeringViaEmail = false;
            this.error = err.message;
          });
      }
    },
    registerWithFb: function () {
			console.log('login in with facebok')
			this.loading = true;
			var provider = new firebase.auth.FacebookAuthProvider();
			provider.addScope('public_profile');
			provider.addScope('email');
			
			firebase.auth().signInWithPopup(provider).then(() => {
				this.navigate()
			}).catch(e => {
				this.loading = false;
				console.log(e)
			})
		},
		registerWithGoogle: function () {
			var provider = new firebase.auth.GoogleAuthProvider();
			firebase.auth().signInWithPopup(provider).then(() => {
				this.navigate()

			}).catch(e => {
				this.loading = false;
				console.log(e)
			})
		},
		navigate: async function () {
      localStorage.setItem('_devK', uuidv4())
			let user = await firebase.getCurrentUser();
			let token = await user.getIdToken();
			
			this.$store.commit("setAccessToken", token);
			this.$store.commit("setUser", user.toJSON());
      
			let t = token.split('.')[1]
			let {roles} = JSON.parse(atob(t))
		
			if (!roles || roles && roles.indexOf('registered') === -1) {

				this.$store.dispatch('updateDevice', {
					uuid: localStorage.getItem('_devK'),
          "settings": {
            "stakeAmount": 10,
            "startingEquity": 1000,
            "setupDate": new Date(),
            "currencyCode": "EUR"
          },
				}).then(() => {
					user.getIdToken(true).then(newToken => {
						
						this.$store.commit("setAccessToken", newToken);
            if (!user.emailVerified) {
              firebase.auth().currentUser.sendEmailVerification().then(() => {
                this.$router.replace({ name: "VerifyEmail" })
              })
            } else {
              this.$router.replace({ name: "Home" });
            }
					})
				})
			} else {
				this.$router.replace({ name: "Home" });
			}
			
		}
  }
};
</script>